export const PLATFORM_TITLE = 'Kyros';

export function buildDocumentTitle(pageTitle?: string | null): string {
  const normalized = pageTitle?.trim();
  if (normalized) return `${normalized} | ${PLATFORM_TITLE}`;
  return PLATFORM_TITLE;
}
